import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setWasRead
} from 'store/redux/notifications'

export default function * requestMarkNotificationAsRead (action) {
  const { id } = action.payload

  const state = yield select()

  const notification = state.kanbo.notifications.notificationsById[id]

  if (!notification) return

  const optimisticAction = yield optimisticPut(setWasRead({
    id,
    wasRead: true
  }))

  try {
    yield call(apiAction, 'MarkNotificationAsRead', {
      id
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
